import React, { Suspense } from "react";
import { Config, MetadataDict } from "../types";
import Region from "./Region";
import * as resourceInfo from "../resourceInfo.json";
import { useFrame } from "@react-three/fiber";

let colormap = require("colormap");

export default function Brain({
  metadataDict,
  config,
  setConfig,
}: {
  metadataDict: MetadataDict;
  config: Config;
  setConfig: React.Dispatch<React.SetStateAction<Config>>;
}) {
  let colors: any = Array.from({ length: 102 }, (x, i) => i).map((i) => {
    return "#ff00ff";
  });

  if (config.colormap === "cortex") {
    colors = Array.from({ length: 103 }, (x, i) => i)
      .slice(1)
      .map((i) => {
        return metadataDict[i].isCortex ? "#ff00ff" : "#ff0000";
      });
  } else if (config.colormap === "id") {
    colors = colormap({
      colormap: "jet",
      nshades: 102,
      format: "hex",
      alpha: 1,
    });
  } else if (config.colormap === "resource") {
    colors = Array.from({ length: 103 }, (x, i) => i)
      .slice(1)
      .map((i) => {
        // @ts-ignore
        return metadataDict[i].resourceId ? resourceInfo[metadataDict[i].resourceId].color : "#95a5a6";
      });
  }

  const regions = Array.from({ length: 103 }, (x, i) => i)
    .slice(1)
    .map((region_id) => {
      return (
        <Suspense fallback={null} key={"region" + region_id}>
          <Region
            metadata={metadataDict[region_id]}
            config={config}
            color={colors[region_id - 1]}
            setConfig={setConfig}
          />
        </Suspense>
      );
    });

  return <>{regions}</>;
}
